import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import * as React from 'react';
import { useTheme } from '@emotion/react';
import ChevronLeftRoundedIcon from '@mui/icons-material/ChevronLeftRounded';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import {
  Button,
  Divider,
  Grid,
  IconButton,
  InputAdornment,
  Menu,
  MenuItem,
  Stack,
  Tab,
  Tabs,
  TextField,
  ThemeProvider,
  Tooltip,
  Typography,
  createTheme,
  useMediaQuery,
} from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import { Box } from '@mui/system';
import { ReactComponent as DownloadIcon } from 'assets/icons/DownloadIcon.svg';
import { ReactComponent as InsightIcon } from 'assets/icons/insightIcon.svg';
import { ReactComponent as Location } from 'assets/icons/location.svg';
import {
  BuyerSection,
  graphbox,
  propertyDetail,
} from './ModelGraphExpand.style';
import { Variationbox } from 'component/StatusCardContainer/StatusCardContainer';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { useState } from 'react';
import {
  AboutGraph,
  ChartFilter,
  CloseIcon,
  ConvergeIcon,
  ConversationStatistics,
  CurrentWeekInspection,
  DemographicMap,
  ExpandIcon,
  FilterIcon,
  InspectionOverview,
  MarketOverview,
  MenuIcon,
  NumberOfOffers,
  OfferComparison,
  OfferVsMarket,
  SearchIcon,
  TotalInspectionCount,
} from './ModelGraphExpandIcons';
import {
  poppins300,
  poppins400,
  poppins500,
  poppins600,
} from 'theme/common.style';
import { makeStyles } from '@mui/styles';
import { useContext } from 'react';
import { PropertyContext } from 'component/PropertyContext/PropertyContext';

export default function ChartModel(props) {
  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matchesmd = useMediaQuery(theme.breakpoints.down('md'));
  const matcheslg = useMediaQuery(theme.breakpoints.down('lg'));
  const matchesxl = useMediaQuery(theme.breakpoints.down('xl'));
  const matches700 = useMediaQuery(theme.breakpoints.down(700));
  const matches = useMediaQuery(theme.breakpoints.down(1200));
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);

  const [expandModal, setExpandModal] = useState(false);
  const [tabValue, setTabValue] = useState(0);

  const { collapsed } = useContext(PropertyContext);

  const formatAmount = (value) => {
    return `$${Math.round(Number(value)).toLocaleString('en-US')}`;
  };

  const headerData = [
    {
      name: 'Buyers Section 1',
      label: 'Current Week Inspection',
      id: 1,
      icon: <CurrentWeekInspection color={'#666666'} />,
      iconActive: <CurrentWeekInspection color={'#212121'} />,
    },
    {
      name: 'Buyers Section 2',
      label: 'Total Inspection Count',
      id: 2,
      icon: <TotalInspectionCount color={'#666666'} />,
      iconActive: <TotalInspectionCount color={'#212121'} />,
    },
    {
      name: 'Buyers Section 3',
      label: 'Inspection Overview',
      id: 3,
      icon: <InspectionOverview color={'#666666'} />,
      iconActive: <InspectionOverview color={'#212121'} />,
    },
    {
      name: 'Interested Section 1',
      label: 'Conversion Statistics',
      id: 4,
      icon: <ConversationStatistics color={'#666666'} />,
      iconActive: <ConversationStatistics color={'#212121'} />,
    },
    {
      name: 'Interested Section 2',
      label: 'Demographic Map',
      id: 5,
      icon: <DemographicMap color={'#666666'} />,
      iconActive: <DemographicMap color={'#212121'} />,
    },
    {
      name: 'Interested Section 3',
      label: 'Market Overview',
      id: 6,
      icon: <MarketOverview color={'#666666'} />,
      iconActive: <MarketOverview color={'#212121'} />,
    },
    {
      name: 'Offers Section 1',
      label: 'Number of Offers',
      id: 7,
      icon: <NumberOfOffers color={'#666666'} />,
      iconActive: <NumberOfOffers color={'#212121'} />,
    },
    {
      name: 'Offers Section 2',
      label: 'Offer Comparison',
      id: 8,
      icon: <OfferComparison color={'#666666'} />,
      iconActive: <OfferComparison color={'#212121'} />,
    },
    {
      name: 'Offers Section 3',
      label: 'Offer vs Market Variance',
      id: 9,
      icon: <OfferVsMarket color={'#666666'} />,
      iconActive: <OfferVsMarket color={'#212121'} />,
    },
  ];

  const {
    propertyData,
    handleCardClick,
    active,
    currentweek,
    setLeftDisabled,
    setRightDisabled,
    leftDisabled,
    rightDisabled,
    openModel,
    variation,
    leftColumn1,
    leftColumn2,
    leftColumn3,
    filteroption,
  } = props;
  let leftColumn = active.includes('1')
    ? leftColumn1
    : active.includes('2')
    ? leftColumn2
    : active.includes('3')
    ? leftColumn3
    : null;

  const onDownload = () => {
    const link = document.createElement('a');
    link.download = `download.txt`;
    link.href = propertyData?.reportURL;
    link.click();
  };
  const useStyles = makeStyles({
    tab: {
      minHeight: '24px', // Set the desired minimum height here
    },
    dialogOverlayStyle: {
      position: 'fixed !important',
      display: 'flex',
      justifyContent: 'end',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      zIndex: 9999,
    },
  });
  const ref = React.useRef(null);

  const handleMenuClick = (e) => {
    setMenuAnchorEl(e.currentTarget);
  };

  const handleClick = (item) => {
    let foundIndex = '';
    let filteredKey = headerData?.filter((single, index) => {
      return single?.name === item;
    });
    foundIndex = filteredKey[0]?.id;

    const data = item?.split(' ');

    if (item?.includes('Buyers')) {
      handleCardClick('buyers', data[2]);
      if (foundIndex - 1 == 0) {
        setLeftDisabled(true);
        setRightDisabled(false);
      } else {
        setLeftDisabled(false);
        setRightDisabled(false);
      }
    } else if (item?.includes('Interested')) {
      handleCardClick('interested', data[2]);
      if (foundIndex - 1 > 0 && foundIndex - 1 < 8) {
        setLeftDisabled(false);
        setRightDisabled(false);
      }
    } else {
      handleCardClick('offers', data[2]);
      if (foundIndex - 1 == 8) {
        setRightDisabled(true);
        setLeftDisabled(false);
      } else {
        setLeftDisabled(false);
        setRightDisabled(false);
      }
    }
  };

  const NextArrow = (item) => {
    let foundIndex = '';
    let nextIndex = '';
    let filteredKey = headerData?.filter((single, index) => {
      return single?.name === item;
    });
    foundIndex = filteredKey[0]?.id;

    let filteredNextKey = headerData?.filter((single, index) => {
      if (single?.id === foundIndex - 1 && foundIndex + 1 == 9) {
        setRightDisabled(true);
      }
      return single?.id === foundIndex + 1;
    });

    nextIndex = filteredNextKey[0]?.name;
    handleClick(nextIndex);
  };

  const PrevArrow = (item) => {
    let foundIndex = '';
    let prevIndex = '';
    let filteredKey = headerData?.filter((single, index) => {
      return single?.name === item;
    });
    foundIndex = filteredKey[0]?.id;

    let filteredPrevKey = headerData?.filter((single, index) => {
      if (single?.id === foundIndex - 1 && foundIndex - 1 == 1) {
        setLeftDisabled(true);
      }
      return single?.id === foundIndex - 1;
    });
    prevIndex = filteredPrevKey[0]?.name;

    handleClick(prevIndex);
  };

  const handleTabValueChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const classes = useStyles();
  const handleMenuClose = () => {
    setMenuAnchorEl(null);
  };

  const isFullScreen = matchessm || matchesmd || matcheslg;
  return (
    <Dialog
      open={props.open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className={classes.dialogOverlayStyle}
      hideBackdrop
      // disableEnforceFocus
      sx={{
        width: isFullScreen || expandModal ? '100vw' : '100vw',
        // backgroundColor:"#FAFAFA",
        '& .MuiDialog-container': {
          alignItems: 'flex-start',
          width: isFullScreen || expandModal ? '100vw' : '100vw',
          '& .MuiPaper-root': {
            scrollbarWidth: 'none',
            width: '100%',
            maxWidth: '100%',
            height: '100%',
            padding: isFullScreen ? '0px' : '5px',
            borderRadius: isFullScreen ? '0px' : expandModal ? '0px' : '15px',
            margin: isFullScreen ? '0px' : 'auto',
            top: isFullScreen ? '0px' : expandModal ? '0px' : '0px',
            transition: 'all 0.3s ease-in-out',
            marging: 'auto',
            boxShadow: expandModal ? 'none' : 'auto',
          },
        },
      }}
    >
      <Stack
        direction={'row'}
        sx={{
          backgroundColor: '#FAFAFA',
          padding: matchessm ? '15px' : '30px 15px',
        }}
      >
        {!matchessm && !matchesmd && !matcheslg && (
          <Grid
            sx={{
              width: expandModal || isFullScreen ? '61px' : '286px',
              display: 'flex',
              flexDirection: 'column',
              gap: '30px',
              justifyContent: 'flex-start',
              backgroundColor: '#FAFAFA',
            }}
          >
            {/* {expandModal || isFullScreen ? (
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <IconButton
                  onClick={() => setExpandModal((prev) => !prev)}
                  sx={{
                    width: '45px',
                    height: '45px',
                    backgroundColor: '#FFFFFF',
                    border: '1px solid #D9D9D9',
                    '&:hover': {
                      backgroundColor: '#F5F5F5',
                    },
                  }}
                >
                  <SearchIcon />
                </IconButton>
              </Box>
            ) : (
              <TextField
                variant="outlined"
                placeholder="Search here"
                sx={{
                  width: '100%',
                  fontSize: '14px',
                  '.MuiInputAdornment-root': {
                    alignItems: 'center',
                  },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment
                      position="start"
                      sx={{
                        cursor: 'pointer',
                      }}
                      onClick={() => setExpandModal((prev) => !prev)}
                    >
                      <SearchIcon />
                    </InputAdornment>
                  ),
                  style: {
                    borderRadius: '50px',
                    height: '45px',
                    paddingLeft: '10px',
                    backgroundColor: '#f9f9f9',
                  },
                }}
              />
            )} */}
            {/* <Divider /> */}
            {headerData.map((item, i) => {
              return (
                <Tooltip
                  title={item.label}
                  disableHoverListener={!expandModal}
                  placement="right"
                  componentsProps={{
                    tooltip: {
                      sx: {
                        fontFamily: 'Poppins, sans-serif', // Change font family
                        fontSize: '12px', // Change font size
                        padding: '5px 25px',
                      },
                    },
                  }}
                >
                  <Grid className="inner">
                    <Button
                      onClick={() => {
                        handleClick(item.name);
                      }}
                      key={i}
                      sx={{
                        fontFamily: 'Poppins !important',
                        fontStyle: 'normal !important',
                        fontWeight: '500 !important',
                        fontSize: matchessm ? '10px' : '14px',
                        display: 'flex',
                        justifyContent: expandModal ? 'center' : 'flex-start',
                        padding: expandModal ? '5px' : '10px 10px ',
                        backgroundColor: '#FAFAFA',
                        color: active == `${item.name}` ? '#000000' : '#5C5C62',
                        minWidth: expandModal ? '51px' : '100%',
                        height: matchessm
                          ? '28px'
                          : expandModal
                          ? '51px'
                          : '38px',
                        borderRadius: '5px',
                        gap: '20px',
                        border:
                          active == `${item.name}`
                            ? '1px solid #C2C2C2'
                            : 'none',
                        alignItems: 'center',
                        textTransform: 'none',
                        boxShadow:
                          active == `${item.name}`
                            ? ' 0px 2px 6px 0px rgba(0, 0, 0, 0.08)'
                            : 'none',
                        // "&:hover": {
                        //   backgroundColor:
                        //     active == `${item.name}` ? "#6C2AD2" : "#FFFFFF",
                        //   color:
                        //     active == `${item.name}` ? "#FFFFFF" : "#000000",
                        // },
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {active == `${item.name}` ? item.iconActive : item.icon}

                      {expandModal || isFullScreen ? '' : `${item.label}`}
                    </Button>
                  </Grid>
                </Tooltip>
              );
            })}
          </Grid>
        )}
        <Grid
          sx={{
            backgroundColor: isFullScreen ? 'none' : '#FFFFFF',
            padding: isFullScreen ? '0px' : '15px 30px',
            marginX: '10px',
            width: isFullScreen
              ? '100%'
              : expandModal
              ? '100%'
              : 'calc(100% - 286px)',
          }}
        >
          <Grid
            sx={{
              display: 'flex',
              flexDirection: 'row',
              gap: matchessm ? '5px' : '10px',
              justifyContent: 'space-between',
              alignItems: 'flex-end',
            }}
            mb={2}
          >
            <Stack
              direction={'row'}
              sx={{
                gap: isFullScreen ? '5px' : '10px',
                width: isFullScreen ? '100%' : 'fit-content',
                alignItems: 'center',
              }}
            >
              {isFullScreen && (
                <>
                  <IconButton
                    sx={{
                      cursor: 'pointer',
                      width: '33px',
                      height: '33px',
                      padding: '0px',
                      justifyContent: 'left',
                    }}
                    onClick={handleMenuClick}
                  >
                    <MenuIcon />
                  </IconButton>
                  <Menu
                    id="basic-menu"
                    anchorEl={menuAnchorEl}
                    open={Boolean(menuAnchorEl)}
                    onClose={handleMenuClose}
                    MenuListProps={{
                      'aria-labelledby': 'basic-button',
                    }}
                    sx={{
                      alignItems: 'center',
                    }}
                  >
                    <MenuItem>
                      <TextField
                        variant="outlined"
                        placeholder={expandModal ? '' : 'Search here'}
                        sx={{
                          width: '100%',
                          fontSize: '10px',
                          '& .MuiInputBase-input::placeholder': {
                            fontSize: '12px',
                          },
                        }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <SearchIcon />
                            </InputAdornment>
                          ),
                          style: {
                            borderRadius: '50px',
                            height: '28px',
                            paddingLeft: '10px',
                            backgroundColor: '#f9f9f9',
                            marging: 'auto',
                          },
                        }}
                      />
                    </MenuItem>

                    <Divider />
                    {headerData.map((item, i) => {
                      return (
                        <MenuItem>
                          <Grid className="inner">
                            <Button
                              onClick={() => {
                                handleClick(item.name);
                                handleMenuClose();
                              }}
                              key={i}
                              sx={{
                                fontFamily: 'Poppins !important',
                                fontStyle: 'normal !important',
                                fontWeight: '500 !important',
                                fontSize: matchessm ? '10px' : '14px',
                                display: 'flex',
                                justifyContent: expandModal
                                  ? 'center'
                                  : 'flex-start',
                                padding: expandModal ? '5px' : '10px 10px ',
                                backgroundColor: 'white',
                                color:
                                  active == `${item.name}`
                                    ? '#000000'
                                    : '#5C5C62',
                                minWidth: expandModal ? '51px' : '100%',
                                height: matchessm
                                  ? '28px'
                                  : expandModal
                                  ? '51px'
                                  : '38px',
                                borderRadius: '5px',
                                gap: '10px',
                                border:
                                  active == `${item.name}`
                                    ? '1px solid #C2C2C2'
                                    : 'none',
                                alignItems: 'center',
                                textTransform: 'none',
                                boxShadow:
                                  active == `${item.name}`
                                    ? ' 0px 2px 6px 0px rgba(0, 0, 0, 0.08)'
                                    : 'none',
                                // "&:hover": {
                                //   backgroundColor:
                                //     active == `${item.name}` ? "#6C2AD2" : "#FFFFFF",
                                //   color:
                                //     active == `${item.name}` ? "#FFFFFF" : "#000000",
                                // },
                                whiteSpace: 'nowrap',
                              }}
                            >
                              {active == `${item.name}`
                                ? item.iconActive
                                : item.icon}

                              {expandModal ? '' : `${item.label}`}
                            </Button>
                          </Grid>
                        </MenuItem>
                      );
                    })}
                  </Menu>
                </>
              )}
              <Typography
                sx={{
                  ...poppins400,
                  fontSize: matchessm ? '14px' : '20px',
                  color: '#666666',
                  gap: '10px',
                  display: 'flex',
                  // justifyContent:"space-between",
                }}
              >
                Expanded Campaign Insights
              </Typography>
            </Stack>

            <Stack
              direction={'row'}
              sx={{
                gap: isFullScreen ? '5px' : '10px',
              }}
            >
              {/* <Button
                sx={{
                  width: matchessm ? '33px' : '197px',
                  height: isFullScreen ? '33px' : '42px',
                  minWidth: matchessm ? '33px' : 'auto',
                  borderRadius: '5px',
                  border: '1px solid #D9D9D9',
                  flexDirection: 'row',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  textTransform: 'none',
                  cursor: 'pointer',
                  fontFamily: 'Poppins !important',
                  fontStyle: 'normal !important',
                  fontWeight: '400 !important',
                  fontSize: matchessm ? '14px' : '16px',
                  color: '#666666',
                  '.MuiButton-startIcon': {
                    marginRight: isFullScreen ? '0px' : '8px',
                  },
                  '.MuiButtonBase-root': {
                    width: matchessm ? '33px' : '64px',
                    minWidth: matchessm ? '33px' : '64px',
                  },
                }}
                startIcon={<DownloadIcon />}
              >
                {matchessm ? '' : 'Download Report'}
              </Button> */}
              {!matchessm && !matchesmd && !matcheslg && (
                <IconButton
                  sx={{
                    width: isFullScreen ? '33px' : '44px',
                    height: isFullScreen ? '33px' : '44px',
                    borderRadius: '5px',
                    border: '1px solid #D9D9D9',
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    setExpandModal((prev) => !prev);
                  }}
                >
                  {expandModal ? <ConvergeIcon /> : <ExpandIcon />}
                </IconButton>
              )}
              <IconButton
                sx={{
                  width: isFullScreen ? '33px' : '44px',
                  height: isFullScreen ? '33px' : '44px',
                  borderRadius: '5px',
                  border: '1px solid #D9D9D9',
                  cursor: 'pointer',
                }}
                onClick={props.close}
              >
                <CloseIcon />
              </IconButton>
            </Stack>
          </Grid>
          <Grid
            sx={{
              display: 'flex',
              flexDirection: matchesmd ? 'column' : undefined,
              width: '100%',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Grid
              item
              xs={12}
              md={12}
              lg={12}
              xl={12}
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                marginBottom: 2,
              }}
            >
              <Typography>
                <Location
                  width={matchessm ? 20 : matchesmd ? 30 : 34}
                  height={matchessm ? 20 : matchesmd ? 30 : 34}
                />
              </Typography>
              <Tooltip
                title={propertyData?.propertyAddress?.streetName}
                PopperProps={{
                  modifiers: [
                    {
                      name: 'preventOverflow',
                      options: {
                        boundary: 'window',
                      },
                    },
                  ],
                }}
                componentsProps={{
                  tooltip: {
                    sx: {
                      backgroundColor: 'white',
                      color: 'black',
                      fontFamily: 'Poppins',
                      fontSize: '12px',
                      boxShadow: 1,
                    },
                  },
                }}
              >
                <Typography
                  sx={[
                    propertyDetail,
                    {
                      fontSize: matchessm
                        ? '12px'
                        : matchesxl
                        ? '18px'
                        : '27px',
                      width: matchessm ? '80%' : '70%',
                      overflow: 'hidden',
                      whiteSpace: 'nowrap',
                      textOverflow: 'ellipsis',
                      cursor: 'pointer',
                    },
                  ]}
                >
                  {propertyData?.propertyAddress?.streetName}
                </Typography>
              </Tooltip>

              {/* {
                <Typography>
                  <InsightIcon
                    width={matchessm ? 25 : matchesxl ? 30 : 34}
                    height={matchessm ? 25 : matchesxl ? 30 : 34}
                  />
                </Typography>
              } */}
            </Grid>
          </Grid>
          <Stack
            direction={matchessm ? 'column' : 'row'}
            sx={{
              justifyContent: 'right',
            }}
          >
            {/* <Stack
              direction={'row'}
              sx={{
                justifyContent: isFullScreen
                  ? 'space-between'
                  : 'space-between',
                gap: '15px',
              }}
            >
              <Tabs
                value={tabValue}
                onChange={handleTabValueChange}
                sx={{
                  ...poppins600,
                  fontSize: matchessm ? '12px' : '16px',
                  '& .MuiTabs-flexContainer': {
                    bgcolor: '#F5F5F5',
                    padding: 0.5,
                    borderRadius: '8px',
                    minHeight: '33px',
                  },
                  '& .MuiTabs-indicator': { display: 'none' },
                  // "& .Mui-selected": { fontWeight: "bold" },
                  '.MuiTabs-root ': {
                    alignItems: 'center',
                    border: '1px solid blue',
                    minHeight: matchessm ? '33px' : 'auto',
                  },
                  '& .MuiTab-root': {
                    borderRadius: '8px',
                    transition: '0.3s',
                    color: 'gray',
                    textTransform: 'none',
                    minHeight: matchessm ? '33px' : '38px',
                  },
                  '& .Mui-selected': {
                    backgroundColor: '#fff',
                    color: 'black',
                    boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.1)',
                  },
                  textTransform: 'none',
                }}
              >
                <Tab label="Daily" />
                <Tab label="Weekly" />
              </Tabs>
              <Button
                sx={{
                  width: isFullScreen ? 'auto' : '125px',
                  height: isFullScreen ? 'auto' : '47px',
                  borderRadius: '5px',
                  // border: "1px solid #D9D9D9",
                  flexDirection: 'row',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  textTransform: 'none',
                  cursor: 'pointer',
                  fontFamily: 'Poppins !important',
                  fontStyle: 'normal !important',
                  fontWeight: '600 !important',
                  fontSize: '16px',
                  backgroundColor: '#F5F5F5',
                  color: '#262626',
                }}
                startIcon={<FilterIcon />}
              >
                Filter
              </Button>
            </Stack> */}

            <Grid
              sx={{
                display: 'flex',
                flexDirection: 'row',
                // alignItems: "end",
                justifyContent: isFullScreen ? 'flex-end' : 'space-around',
                padding: matchessm ? '17px 0 0 0' : '',
                // paddingRight: matchessm ? "22px" : "",
                gap: isFullScreen ? '10px' : '30px',
              }}
            >
              <Stack
                direction={'row'}
                sx={{
                  gap: isFullScreen ? '5px' : '10px',
                  alignItem: 'center',
                  width: isFullScreen ? 'auto' : '40%',
                  justifyContent: 'end',
                }}
              >
                <Typography
                  sx={{
                    fontFamily: 'Poppins !important',
                    fontStyle: 'normal !important',
                    fontWeight: '400 !important',
                    fontSize: matchessm ? '12px' : matchesxl ? '15px' : '18px',
                    whiteSpace: 'nowrap',
                    display: 'flex',
                    color: '#666666',
                    alignItems: 'center',
                  }}
                >
                  From :
                </Typography>
                <Box
                  sx={{
                    fontFamily: 'Poppins !important',
                    fontStyle: 'normal !important',
                    fontWeight: '400 !important',
                    fontSize: matchessm ? '12px' : matchesxl ? '14px' : '18px',
                    height: matchessm ? '33px' : '47px',
                    borderRadius: '5px',
                    flexDirection: 'row',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textTransform: 'none',
                    cursor: 'none',
                    whiteSpace: 'nowrap',
                    color: '#262626',
                  }}
                >
                  Week 0
                </Box>
              </Stack>

              <Stack
                direction={'row'}
                sx={{
                  gap: '10px',
                  alignItem: 'center',
                  width: isFullScreen ? 'auto' : '40%',
                  justifyContent: 'end',
                }}
              >
                <Typography
                  sx={{
                    fontFamily: 'Poppins !important',
                    fontStyle: 'normal !important',
                    fontWeight: '400 !important',
                    fontSize: matchessm ? '12px' : matchesxl ? '15px' : '18px',
                    whiteSpace: 'nowrap',
                    display: 'flex',
                    alignItems: 'center',
                    color: '#666666',
                  }}
                >
                  To :
                </Typography>
                <Box
                  sx={{
                    fontFamily: 'Poppins !important',
                    fontStyle: 'normal !important',
                    fontWeight: '400 !important',
                    fontSize: matchessm ? '12px' : matchesxl ? '14px' : '18px',
                    height: matchessm ? '33px' : '47px',
                    borderRadius: '5px',
                    flexDirection: 'row',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textTransform: 'none',
                    cursor: 'none',
                    color: '#262626',
                    whiteSpace: 'nowrap',
                  }}
                >
                  Week {currentweek}
                </Box>
              </Stack>
            </Grid>
          </Stack>

          <Grid>
            <Grid
              sx={{
                // width: "100%",
                // height: "100%",
                borderRadius: '10px',
                //backgroundColor: "#FFFFFF",
                marginTop: '25px',
              }}
            >
              <Grid
                container
                // gap={1}
                // md={8}
                // lg={10}
                // xl={12}
                // xs={6}
                sm={12}
                sx={{
                  display: 'flex',
                  padding: isFullScreen ? '0px' : '22px 22px',
                  justifyContent: 'space-between',
                }}
              >
                <Grid
                  sm={12}
                  item
                  lg={
                    active === 'Offers Section 3' || 'Offers Section 2' ? 5 : 4
                  }
                  gap={2}
                  // container
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                  }}
                >
                  {active === 'Buyers Section 1' ? (
                    <>
                      <Variationbox sector1={variation} openModel={openModel} />
                    </>
                  ) : active === 'Offers Section 3' ? (
                    <>
                      {leftColumn?.length > 0 &&
                        leftColumn?.map((keys, index) => {
                          let variance;
                          if (keys.key == 'Indicator') {
                            variance = keys.value;
                          }
                          if (
                            !keys.key?.includes('Total Offers') &&
                            !keys.key?.includes('Indicator')
                          ) {
                            return (
                              <Grid
                                item
                                sx={{
                                  width: '100%',
                                  height: '35%',
                                  borderRadius: '8px',
                                  boxShadow:
                                    'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                }}
                              >
                                <Grid
                                  sx={{
                                    display: 'flex',
                                    height: '100%',
                                    width: '100%',
                                    // justifyContent: "center",
                                    alignItems: 'center',
                                    gap: '10%',
                                    paddingX: '10%',
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      fontFamily: 'poppins',
                                      fontWeight: 400,
                                      fontSize: matchessm
                                        ? '12px'
                                        : matchesxl
                                        ? '16px'
                                        : '20px',
                                      display: 'flex',
                                      justifyContent: 'left',
                                      width: '80%',
                                      padding: matcheslg ? '10px' : '',
                                    }}
                                  >
                                    {/* {keys[0].toUpperCase() + keys.slice(1)} */}
                                    {keys.key}
                                  </Typography>
                                  <Typography
                                    sx={{
                                      display: 'flex',
                                      justifyContent: 'right',
                                      fontFamily: 'poppins',
                                      fontWeight: 600,
                                      fontSize: matchessm
                                        ? '12px'
                                        : matchesxl
                                        ? '16px'
                                        : '20px',
                                      padding: matcheslg ? '10px' : '',
                                      width: '20%',
                                      color:
                                        keys?.key == 'Variance' &&
                                        variance == 'negative'
                                          ? 'red'
                                          : '#10D35E',
                                    }}
                                  >
                                    {/* {Math.round(leftColumn?.campaign[keys])} */}
                                    {keys?.key == 'Variance' &&
                                    variance == 'negative'
                                      ? '-'
                                      : null}{' '}
                                    {keys?.key != 'Variance'
                                      ? formatAmount(keys.value)
                                      : Math.round(keys.value)}
                                  </Typography>
                                </Grid>
                              </Grid>
                            );
                          }
                        })}
                    </>
                  ) : (
                    <>
                      {leftColumn?.length > 0 &&
                        leftColumn?.map((keys, index) => {
                          return (
                            <Grid
                              item
                              sx={{
                                width: '100%',
                                height: '35%',
                                borderRadius: '8px',
                                boxShadow:
                                  'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                              }}
                            >
                              <Typography
                                sx={{
                                  display: 'flex',
                                  height: '100%',
                                  // justifyContent: "center",
                                  alignItems: 'center',
                                  gap: '10%',
                                  paddingX: '10%',
                                }}
                              >
                                <Typography
                                  sx={{
                                    fontFamily: 'poppins',
                                    fontWeight: 400,
                                    fontSize: matchessm
                                      ? '12px'
                                      : matchesxl
                                      ? '16px'
                                      : '20px',
                                    width: '80%',
                                    display: 'flex',
                                    justifyContent: 'left',
                                    padding: matcheslg ? '10px' : '',
                                  }}
                                >
                                  {keys.key}
                                </Typography>
                                <Typography
                                  sx={{
                                    fontFamily: 'poppins',
                                    fontWeight: 600,
                                    fontSize: matchessm
                                      ? '12px'
                                      : matchesxl
                                      ? '16px'
                                      : '20px',
                                    padding: matcheslg ? '10px' : '',
                                    color: '#10D35E',
                                    display: 'flex',
                                    width: '20%',
                                    justifyContent: 'right',
                                  }}
                                >
                                  {keys?.key == 'Campaign Highest Offer' ||
                                  keys?.key == 'Market Highest Offer'
                                    ? formatAmount(keys.value)
                                    : Math.round(keys.value)}
                                </Typography>
                              </Typography>
                            </Grid>
                          );
                        })}
                    </>
                  )}
                </Grid>

                <Grid
                  item
                  lg={
                    active === 'Offers Section 3' || 'Offers Section 2'
                      ? 6.5
                      : 7.5
                  }
                  sx={{
                    // visibility :'hidden',
                    // border :' 1px solid red',
                    width: '350px',
                    height: '350px',
                    borderRadius: '15px',
                    boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                    marginTop: matcheslg ? '10px' : '',
                  }}
                >
                  {props.data}
                </Grid>
              </Grid>
              <Grid
                container
                sx={{
                  display: 'flex',
                  flexDirection: matchesmd ? 'column' : 'row',
                  justifyContent: 'space-between',
                  width: '100%',
                  gap: '22px',
                  padding: matchessm ? '22px 0px' : '22px 22px',
                }}
                gap={1}
              >
                <Grid
                  item
                  xs={12}
                  md={5.5}
                  // md={12}
                  sx={{
                    borderRadius: '8px',
                    border: '1px solid #F0F0F0',
                    // width:"100%"
                  }}
                >
                  <Grid
                    sx={{
                      display: 'flex',
                      // justifyContent:"center"
                      alignItems: 'center',
                      gap: '16px',
                      padding: '15px 0',
                      margin: '0 18px',
                    }}
                  >
                    <AboutGraph />

                    <Typography
                      sx={{
                        fontFamily: 'poppins',
                        fontWeight: 600,
                        fontSize: matchessm ? '14px' : '20px',
                      }}
                    >
                      About this Graph
                    </Typography>
                  </Grid>
                  <Grid
                    sx={{
                      display: 'flex',
                      // justifyContent:"center"
                      alignItems: 'center',
                      gap: '16px',
                      //padding: "15px 0",
                      margin: '0 15px',
                      marginLeft: '60px',
                    }}
                  >
                    <Typography
                      sx={{ fontFamily: 'poppins', textAlign: 'justify' }}
                    >
                      {active === 'Buyers Section 1' ? (
                        <Typography
                          sx={{
                            fontFamily: 'poppins',
                            lineHeight: '30px',
                            fontSize: matchessm ? '12px' : '16px',
                            lineHeight: matchessm ? '0' : '',
                          }}
                        >
                          The graph above plots the campaign inspection
                          attendance results and highlights the variance when
                          compared to other similar campaigns across comparable
                          time period
                        </Typography>
                      ) : active === 'Buyers Section 2' ? (
                        <Typography
                          sx={{
                            fontFamily: 'poppins',
                            lineHeight: '30px',
                            fontSize: matchessm ? '12px' : '16px',
                            lineHeight: matchessm ? '0' : '',
                          }}
                        >
                          {' '}
                          The line chart illustrates the total buyer inspection
                          count as the campaign progresses and offers a
                          comparison view with similar campaigns.
                        </Typography>
                      ) : active === 'Buyers Section 3' ? (
                        <Typography
                          sx={{
                            fontFamily: 'poppins',
                            lineHeight: '30px',
                            fontSize: matchessm ? '12px' : '16px',
                          }}
                        >
                          The radar above illustrates a high level overview of
                          the entire campaign performance. An additional web
                          enables comparison with average market performance for
                          like campaigns.
                        </Typography>
                      ) : active === 'Interested Section 1' ? (
                        <Typography
                          sx={{
                            fontFamily: 'poppins',
                            lineHeight: '30px',
                            fontSize: matchessm ? '12px' : '16px',
                            lineHeight: matchessm ? '0' : '',
                          }}
                        >
                          The bar graph provides an overview of the campaign’s
                          conversion statistics.
                        </Typography>
                      ) : active === 'Interested Section 2' ? (
                        <Typography
                          sx={{
                            fontFamily: 'poppins',
                            lineHeight: '30px',
                            fontSize: matchessm ? '12px' : '16px',
                            lineHeight: matchessm ? '0' : '',
                          }}
                        >
                          A pie graph depicts buyers segmented according to
                          their buying profile. Each slice represents the total
                          percentage of the campaign and segments each buyer by
                          profile.
                        </Typography>
                      ) : active === 'Interested Section 3' ? (
                        <Typography
                          sx={{
                            fontFamily: 'poppins',
                            lineHeight: '30px',
                            fontSize: matchessm ? '12px' : '16px',
                            lineHeight: matchessm ? '0' : '',
                          }}
                        >
                          A radar graph allows viewer to compare interested
                          parties each week against market average results for
                          same time period.
                        </Typography>
                      ) : active === 'Offers Section 1' ? (
                        <Typography
                          sx={{
                            fontFamily: 'poppins',
                            lineHeight: '30px',
                            fontSize: matchessm ? '12px' : '16px',
                            lineHeight: matchessm ? '0' : '',
                          }}
                        >
                          A line graph plots total offers received each week,
                          showing offer trend over the course of the campaign. A
                          market comparison line can be enabled.
                        </Typography>
                      ) : active === 'Offers Section 2' ? (
                        <Typography
                          sx={{
                            fontFamily: 'poppins',
                            lineHeight: '30px',
                            fontSize: matchessm ? '12px' : '16px',
                            lineHeight: matchessm ? '0' : '',
                          }}
                        >
                          All offers received throughout the campaign are
                          plotted over time. Offers of similar value are grouped
                          together.
                        </Typography>
                      ) : active === 'Offers Section 3' ? (
                        <Typography
                          sx={{
                            fontFamily: 'poppins',
                            lineHeight: '30px',
                            fontSize: matchessm ? '12px' : '16px',
                            lineHeight: matchessm ? '0' : '',
                          }}
                        >
                          The campaigns lowest, median and highest offers
                          received to date are plotted on the scatter graph. By
                          enabling market comparison, the campaign’s variance is
                          highlighted.
                        </Typography>
                      ) : null}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={5.5}
                  sx={{
                    borderRadius: '8px',
                    border: '1px solid #F0F0F0',
                    // boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
                  }}
                >
                  {filteroption}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Stack>
    </Dialog>
  );
}
